import * as React from 'react';
import PageContainer from "@components/PageContainer";
import Block from "@layout/Block";
import ExternalButton from "@layout/buttons/External";
import Font from "@layout/Font";
import PageTitle from "@layout/PageTitle";
import Pieces from "@layout/pieces/index";
import classnames from 'classnames';
import { FacebookProvider, Like } from 'react-facebook';
import './index.scss';
import { Portfolio } from '@store/index';

interface OwnProps { 
    porfolio: Portfolio;
}

class PortfolioItemPage extends React.Component<OwnProps> {
    render(): JSX.Element {
        const { porfolio } = this.props;

        return (
            <PageContainer>
                <Block indent="20">
                    <PageTitle>
                        { porfolio.name }
                    </PageTitle>
                </Block>
                <Block indent="10">
                    <div className="grid">
                        <div className={classnames('description-main', `grid-${(porfolio.website) ? 8 : 12}`)}>
                            <div>
                                <Block indent="10">
                                    <Font font="secondary" size={20} lineHeight={14}>
                                        { porfolio.description }
                                    </Font>
                                </Block>
                                {/* <FacebookProvider appId={process.env.REACT_APP_FACEBOOK_APP_ID}>
                                    <Like href={window.location.href} colorScheme="dark" showFaces={false} />
                                </FacebookProvider> */}
                            </div>
                        </div>
                        { 
                            porfolio.website &&  
                            <div className="grid-4 text-right link-external">
                                <a href={porfolio.website} target="_blank">
                                    <ExternalButton>
                                        Visit web site
                                    </ExternalButton>
                                </a>
                            </div>
                        }
                    </div>
                </Block>

                <Pieces pieces={porfolio.pieces} />
            </PageContainer>
        );
    }
}

export default PortfolioItemPage;


// WEBPACK FOOTER //
// ./src/components/Portfolio/Item/index.tsx